export enum Roles {
  Admin = 'campaignAdmin',
  Approver = 'campaignApprover',
  Viewer = 'campaignViewer',
  SuperAdmin = 'campaignSuperAdmin',
  CampaignDashboard = 'campaignDashboard',
}
